import React, { Component } from 'react';

class SkillThumb extends Component {
  render() {
    return (
    <div className='skill-thumb'>
        <img src={this.props.image} alt={this.props.alt}/>
        <h4>{this.props.description}</h4>
    </div>
    );
  }
}

export default SkillThumb;